// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1-0Fk","row":"Node_row__3UDDD","label":"Node_label__3l5Sm","footer":"Node_footer__2pqle"};